import Api from "../../../../https/Api";

export class HotelService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    //get
    async getAllHotel() {
        return this.api.get("hotels/hotels");
    }

    async getAllEquipments() {
        return this.api.get("equipments");
    }

    async getHotelByUser(id: string) {
        return this.api.simpleGet("hotels/byUser", id);
    }

    async getHotelById(id: string) {
        return this.api.simpleGet("hotels/get", id);
    }
    //post

    async saveHotel(hotel: any) {
        return this.api.post("hotels/create/", hotel);
    }

    //delete
    async deleteHotel(id: string) {
        return this.api.simpleDeleteById(`hotels/delete`, id);
    }

    async deleteCategories(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("categories/deleteMany", param);
    }

    async deleteEquipments(ids: string[]) {
        const param = {
            ids: ids,
        };
        return this.api.deleteMany("equipments/deleteMany", param);
    }
    async saveDestinationPhotos(Photo: any) {
        return this.api.postFileupload("destinations/upload", Photo);
    }
    async deletePropertyPhotoByName(idProperty: string, photoName: string) {
        return this.api.deletePropertyPhoto(
            "hotels/deletePhoto",
            idProperty,
            photoName
        );
    }

    async savePropertyPhotosById(id: string, hotelPhoto: any) {
        return this.api.postFile("hotels/uploadPhoto", id, hotelPhoto);
    }
    async deletePropertyPhotoById(idProperty: string, idPhoto: string) {
        return this.api.deletePropertyPhoto(
            "hotels/deletePhoto/ById",
            idProperty,
            idPhoto
        );
    }
    async refreshPropertyPhotos(idProperty: string) {
        return this.api.simpleGet("hotels/getPhoto/ById", idProperty);
    }
}
